import Model from '@/shared/orm/Model'
import i18n from '@/plugins/i18n'
import Customer from '@/models/Customer'
import Plan from '@/models/Plan'
import Period from '@/models/Period'

export default class CommissionActivation extends Model {
    resourceName() {
        return 'commissionActivations'
    }

    fields() {
        return ['product', 'value', 'installments', 'installment']
    }

    relationships() {
        return {
            period: new Period(),
            customer: new Customer(),
            plan: new Plan(),
        }
    }

    computed() {
        return {
            formattedValue(item) {
                return i18n.n(item.value, 'currency')
            },

            readableInstallment(item) {
                return `${item.installment}/${item.installments}`
            },
        }
    }
}
